import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { m20, m28 } from '../../styles/typography';
import ArrowDownSvg from '../svg/arrow-down';

const Host = styled.div``;

const Header = styled.button`
  ${m28};
  position: relative;
  padding: ${gutter(2)} 0;
  display: block;
  width: 100%;
  cursor: pointer;

  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    left: 0;
    bottom: 0;

    height: 2px;
    width: ${gutter(5)};

    background-color: ${color('gold60')};
  }
`;

const Flex = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Arrow = styled(motion.span)`
  display: inline-flex;
  width: 17px;
  height: 10px;
`;

const Content = styled(motion.div)`
  overflow: hidden;
`;

const Inner = styled.div`
  padding: ${gutter(2)} 0;

  h2 {
    ${m20};
    margin-top: ${gutter(1)};
    margin-bottom: ${gutter(2)};
  }

  p {
    margin-bottom: ${gutter(2)};
  }

  ul {
    margin-bottom: ${gutter(2)};
  }
`;

interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
}

export const AccordionItem = ({ title, children }: AccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Host>
      <Header type="button" onClick={() => setIsOpen(!isOpen)}>
        <Flex>
          {title}
          <Arrow
            animate={{ rotate: isOpen ? 0 : 180 }}
            transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ArrowDownSvg />
          </Arrow>
        </Flex>
      </Header>
      <AnimatePresence initial={false}>
        {isOpen && (
          <Content
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <Inner>{children}</Inner>
          </Content>
        )}
      </AnimatePresence>
    </Host>
  );
};
